import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

import Button from "../components/Button.js";
import Spinner from "../components/Spinner.js";
import { disconnect } from "../queries/queries";
import { useMutation } from "react-query";
import { useConnection } from "../utilities/codeHooks.js";

const DisconnectButton = ({ children, clearConnection, ...props }) => {
  const { clearStorageCode } = useConnection();
  const { t } = useTranslation();

  const [doDisconnect, { isLoading }] = useMutation(disconnect, {
    onSuccess() {
      clearStorageCode();
      clearConnection();
    },
    onError() {
      toast(<p style={{ color: "#022548" }}>{t("ConnectionHeader.disconnectError")}</p>);
    },
  });

  const disconnectConnection = () => {
    doDisconnect();
  };

  return (
    <>
      <Button onClick={() => disconnectConnection()} {...props}>
        {children}
        <>&nbsp;</> {/* Sorry, no time to write custom CSS for this */}
        {isLoading && <Spinner size={16} />}
      </Button>
    </>
  );
};
export default DisconnectButton;
